import axios from 'axios';

//API Adresse : https://geo.api.gouv.fr/adresse
const apiDataGouvUrl = 'https://api-adresse.data.gouv.fr/search/?q=';
const apiDataGouvUrlParams = '&type=municipality&limit=10';
const apiDataGouvUrlReverse = 'https://api-adresse.data.gouv.fr/reverse/?';

export default class AutocompletionLocationService {
  /**
   * Retrieve location by its name
   * @param searchInputText
   */
  public retrieveLocations(searchInputText: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(apiDataGouvUrl + `${searchInputText}` + apiDataGouvUrlParams)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * Retrieve location by its coordinates (latitude and longitude)
   * @param lat
   * @param long
   */
  public retrieveLocationsByLatLong(lat: string, long: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(apiDataGouvUrlReverse + `lon=${long}&lat=${lat}`)
        .then(res => {
          resolve(res.data.features[0].properties.city);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
